import React from "react";
import { VariantProps } from ".";
import StandardPrice from "../StandardPrice";
import GetPriceByText from "./GetPriceByText";
import GetPriceByEmail from "./GetPriceByEmail";
import WhyWeDoThis from "./WhyWeDoThis";
import GoogleViewPrice from "../GoogleViewPrice";
import PlusShippingLevels from "../PlusShippingLevels";
const A = ({
  price,
  unitOfMeasure,
  user,
  hasWebPlusDiscountedShipping,
  allowWebPlusDiscountedShipping,
  isWebstaurantPlusEligible,
  itemNumber,
  showBelowMinimumAdvertisedPriceForLoggedInCustomers,
  minimumBuy,
  mustBuy,
  isGoogleView,
  chatHours
}: VariantProps) => {
  return <div className="map map-override mapA" data-sentry-component="A" data-sentry-source-file="A.tsx">
      {isGoogleView ? <GoogleViewPrice price={price.price} minimumBuy={minimumBuy} mustBuy={mustBuy} /> : <StandardPrice price={price.price} unitOfMeasure={unitOfMeasure} />}
      <PlusShippingLevels hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping} isWebstaurantPlusEligible={isWebstaurantPlusEligible} user={user} data-sentry-element="PlusShippingLevels" data-sentry-source-file="A.tsx" />
      <GetPriceByText itemNumber={itemNumber} user={user} showLoginLink={showBelowMinimumAdvertisedPriceForLoggedInCustomers} showContactPhoneNumber chatHours={chatHours} data-sentry-element="GetPriceByText" data-sentry-source-file="A.tsx" />
      {!price.hideWhyDoWeDoThis && <WhyWeDoThis type="contact" />}
      <GetPriceByEmail itemNumber={itemNumber} data-sentry-element="GetPriceByEmail" data-sentry-source-file="A.tsx" />
    </div>;
};
export default A;